import { getPlanModalProps } from '../../../lib/plans'
import UserPlanModal from '../../Modals/UserPlanModal';

export default (dispatch) => ({
  enableTerrainAnalysis: () => {
    dispatch({
      type: 'terrain/setEnabledStatus',
      payload: true,
    });
  },
  disableTerrainAnalysis: () => {
    dispatch({
      type: 'terrain/setEnabledStatus',
      payload: false,
    });
  },
  setAspectValues: (aspect) => {
    dispatch({
      type: 'terrain/setAspectValues',
      payload: aspect
    });
  },
  setElevationValues: (elevation) => {
    dispatch({
      type: 'terrain/setElevationValues',
      payload: elevation,
    });
  },
  setOpacityValue: (opacity) => {
    dispatch({
      type: 'terrain/setOpacityValue',
      payload: opacity
    });
  },
  setSlopeValues: (slope) => {
    dispatch({
      type: 'terrain/setSlopeValues',
      payload: slope
    });
  },
  setTerrainValues: (values) => {
    dispatch({
      type: 'terrain/setAllPreferences',
      payload: values
    });
  },
  resetFilters: () => {
    dispatch({
      type: 'terrain/setDefaultFilters'
    });
  },
  toggleUserPlanModal: (props) => {
    let planModalProps = props
    if (!planModalProps.dispatch) {
      planModalProps = {
        ...planModalProps,
        dispatch
      }
    }
    const userPlan = getPlanModalProps(planModalProps)
    setTimeout(() => {
      dispatch({
        type: 'modals/add',
        payload: {
          props: userPlan,
          component: UserPlanModal
        }
      });
    }, 250)
  },
});
